import { ReactNode } from 'react';

import { ACTIVITIES_COMPONENT_TYPE_COLUMNS } from 'global/constants';
import * as Styled from './components-view-wrapper.style';
import { ColourItem } from 'approot/shared/colour/colour-token.style';

type Props = {
  id?: string;
  type: string;
  children: ReactNode;
  colours?: ColourItem | null;
  showBorder?: boolean;
  showBackground?: boolean;
};

const ComponentsViewWrapper = ({
  id,
  type,
  children,
  colours,
  showBorder,
  showBackground,
}: Props) => {
  const isColumnComponent = type === ACTIVITIES_COMPONENT_TYPE_COLUMNS;
  return (
    <Styled.ComponentViewWrapper
      id={id ? `component-${id}` : undefined}
      $marginBottom={isColumnComponent ? 0 : undefined}
      data-selector={type}
      $colours={colours}
      $showBorder={showBorder}
      $showBackground={showBackground}
    >
      {children}
    </Styled.ComponentViewWrapper>
  );
};

export default ComponentsViewWrapper;
